import React from 'react';

import { Grid } from 'vendors/semantic-ui';
import { HashLink } from 'react-router-hash-link';
import { ProductPriceDropdownProps } from './product-price-dropdown-type';
import { ProductQuantityDropdown } from './product-quantity-dropdown';
import { ProductVariantsDropdown } from './product-variants-dropdown';

import styles from './product-price-dropdown-component.module.css';

export const ProductPriceDropdown: React.FC<ProductPriceDropdownProps> = ({
    variants,
    onChange,
}: ProductPriceDropdownProps) => {
    if (variants && variants.length > 0) {
        return (
            <div>
                <div className={variants.length > 1 ? styles.labelsContainer : ''}>
                    <Grid className={`full-width ${styles.noMargin} ${styles.grid}`}>
                        <Grid.Row className={styles.row}>
                            <Grid.Column width={3} className={`${styles.label} `}>
                                Quantité
                            </Grid.Column>
                            <Grid.Column width={9} className={styles.label}>
                                {variants.length > 1 && 'Détails'}
                            </Grid.Column>
                            <Grid.Column width={4} className={styles.label}>
                                Prix Unitaire
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
                {variants.length > 1 && <ProductVariantsDropdown variants={variants} onChange={onChange} />}
                {variants.length === 1 && <ProductQuantityDropdown onChange={onChange} variant={variants[0]} />}

                <div className={styles.priceMention}>
                    Prix non garantis - <HashLink to="/aide#CATALOGUE">EN SAVOIR PLUS</HashLink>
                </div>
            </div>
        );
    }
    return <React.Fragment></React.Fragment>;
};
